export const PDV_NOVO_V3_LOCALSTORAGE_KEY = 'promokit.pdv.novo-v3.habilitado';
export const ROTA_NOVO_PEDIDO_LEGADO = '/admin/pedidos/novo';
export const ROTA_NOVO_PEDIDO_V3 = '/admin/pedidos/novo-v3';

export function leiaFlagPdvNovoV3Local(): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const value = window.localStorage.getItem(PDV_NOVO_V3_LOCALSTORAGE_KEY);
    return value === '1' || value === 'true';
  } catch (e) {
    return false;
  }
}

export function salveFlagPdvNovoV3Local(habilitado: boolean): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(PDV_NOVO_V3_LOCALSTORAGE_KEY, habilitado ? '1' : '0');
  } catch (e) {
    // Ignora falhas de persistencia local (ex.: storage bloqueado pelo navegador).
  }
}

export function obtenhaRotaNovoPedidoLocal(): string {
  return leiaFlagPdvNovoV3Local() ? ROTA_NOVO_PEDIDO_V3 : ROTA_NOVO_PEDIDO_LEGADO;
}
